import WHowResults from './WHowResults'

export default WHowResults
